import { Pipe, PipeTransform, Injectable } from '@angular/core';
import {
  ArtistPublicContent,
  ArtistPublicContentType,
} from '../models/artist/artist-public-content';

@Pipe({
  name: 'artistPublicContents',
  pure: false,
  standalone: false,
})
@Injectable()
export class ArtistPublicContentsPipe implements PipeTransform {
  transform(
    artistPublicContents: ArtistPublicContent[],
    contentType: ArtistPublicContentType,
    sortBy: string = 'position',
  ): any {
    if (!artistPublicContents || !contentType) {
      return artistPublicContents;
    }

    return artistPublicContents
      .filter(
        (artistPublicContent) =>
          artistPublicContent.contentType === contentType,
      )
      .sort((a, b) => {
        if (sortBy === 'position') {
          return a[sortBy] - b[sortBy];
        } else {
          return a.content[sortBy].localeCompare(b.content[sortBy]);
        }
      })
      .map((artistPublicContent) => artistPublicContent.content);
  }
}
